import { aiChatService } from './aiChatService';

const polishingPrompts = {
  grantWriter: `As a professional grant writing expert, please review and polish this grant proposal. 
  Ensure it follows best practices for grant writing including:
  - Professional and authoritative tone
  - Clear section headers and formatting
  - Proper paragraph spacing and organization
  - Compelling executive summary
  - Strong data presentation
  - Impactful conclusion
  Please maintain all factual content but enhance the presentation and polish.`,

  researchAssistant: `As a professional research analyst, please review and polish this research report.
  Ensure it follows academic and professional standards including:
  - Executive summary with key findings
  - Clear methodology section
  - Professional data presentation
  - Proper citations and references
  - Logical flow between sections
  - Strong conclusions and recommendations
  Please maintain all research findings but enhance the presentation and polish.`,

  sqlWriter: `As a senior database architect, please review and polish this SQL documentation.
  Ensure it follows best practices including:
  - Clear query documentation
  - Proper SQL formatting and style
  - Performance considerations
  - Table relationship explanations
  - Index recommendations
  - Query optimization notes
  Please maintain the core SQL logic but enhance the presentation and documentation.`,

  pySparkWriter: `As a senior data engineer, please review and polish this PySpark code and documentation.
  Ensure it follows best practices including:
  - Clear code documentation
  - Proper PySpark best practices
  - Performance optimization notes
  - Data flow explanations
  - Error handling recommendations
  - Memory management considerations
  Please maintain the core logic but enhance the code quality and documentation.`,

  lessonPlanCreator: `As a professional curriculum developer, please review and polish this lesson plan.
  Ensure it follows educational best practices including:
  - Clear learning objectives
  - Engaging activities and transitions
  - Assessment strategies
  - Differentiation options
  - Materials and resources needed
  - Time management recommendations
  Please maintain the core content but enhance the educational value and presentation.`,

  courseOutlineCreator: `As a professional instructional designer, please review and polish this course outline.
  Ensure it follows curriculum development best practices including:
  - Clear course objectives
  - Logical progression of topics
  - Assessment strategies
  - Required resources
  - Prerequisites and requirements
  - Learning outcomes
  Please maintain the core content but enhance the educational structure and presentation.`,

  trainingManualCreator: `As a professional training developer, please review and polish this training manual.
  Ensure it follows training best practices including:
  - Clear learning objectives
  - Step-by-step instructions
  - Visual aids and examples
  - Practice exercises
  - Assessment criteria
  - Reference materials
  Please maintain the core content but enhance the training effectiveness and presentation.`,

  default: `As a professional editor, please review and polish this content.
  Ensure it follows professional standards including:
  - Clear and concise language
  - Logical organization
  - Professional formatting
  - Consistent tone
  - Proper transitions
  - Strong conclusions
  Please maintain all core content but enhance the presentation and polish.`
};

export const outputPolishingService = {
  async polishOutput(content, appType = 'default') {
    try {
      // Select the appropriate polishing prompt
      const polishingPrompt = polishingPrompts[appType] || polishingPrompts.default;
      
      // Combine the content with the polishing prompt
      const fullPrompt = `${polishingPrompt}\n\nOriginal Content:\n${content}`;
      
      // Get polished version from AI service
      const response = await aiChatService.generateResponse(
        fullPrompt,
        [],
        'contentPolisher'
      );
      
      return response.content;
    } catch (error) {
      console.error('Error polishing output:', error);
      // If polishing fails, return original content
      return content;
    }
  }
}; 